import Carousel from "react-bootstrap/Carousel";
import React from "react";

const Slider = () => {
  return (
    <div style={{ marginTop: "60px" }}>
      <Carousel fade>
        <Carousel.Item>
          <img
            className="d-block w-100"
            src="assets/img/kerala.png"
            alt="First slide"
          />
          <Carousel.Caption>
            <h3>Kerala</h3>
          </Carousel.Caption>
        </Carousel.Item>
        <Carousel.Item>
          <img
            className="d-block w-100"
            src="assets/img/rishikesh.png"
            alt="Second slide"
          />

          <Carousel.Caption>
            <h3>Rishikesh</h3>
          </Carousel.Caption>
        </Carousel.Item>
        <Carousel.Item>
          <img
            className="d-block w-100"
            src="assets/img/shimla.png"
            alt="Third slide"
          />

          <Carousel.Caption>
            <h3>Shimla</h3>
          </Carousel.Caption>
        </Carousel.Item>
      </Carousel>
    </div>
  );
};

export default Slider;
